import {
    GetCurrentUserAccountResponseIds,
    useGetIdsUsersMyAccountHealthcareserviceHcsId,
} from '@toktokdoctech/tokapi-client'
import { UserFormErrorContextProvider, defaultUserErrorValues } from './utils/userFormErrorContext'
import { UserFormContextProvider, defaultValues } from './utils/userFormContext'
import useCurrentHcs from '../../hooks/useCurrentHcs'
import { UserFormCallout } from '../feature/userFormCallout/UserFormCallout'
import { MyAccountForm } from './MyAccountForm'
import { UserData } from './_props'
import useCurrentUser from '../../hooks/useCurrentUser'
import { UserLoader } from './UserLoader'

export const MyAccount = () => {
    const currentUser = useCurrentUser()
    const { id: hcsId } = useCurrentHcs()

    const transformUserData = (detail: GetCurrentUserAccountResponseIds): UserData => {
        const profession = detail.professions.at(0)
        if (!profession) throw new Error('[Caregiver Edition] profession list is empty!')

        return {
            objectId: currentUser.id,
            firstName: detail.firstName,
            lastName: detail.lastName,
            civility: detail.civility,
            title: currentUser.title || '',
            rpps: detail.rppsNum ?? undefined,
            validRpps: !!detail.rppsNum,
            category: detail.category || undefined,
            profession: profession.name,
            professionId: profession.id,
            qualification: detail.qualification?.name ?? '',
            qualificationId: detail.qualification?.id,
            speciality: detail.speciality?.name,
            specialityId: detail.speciality?.id,
            positionName: detail.position?.name,
            positionId: detail.position?.id,
            role: {
                id: detail.role?.id ?? '',
                name: detail.role?.name ?? '',
                code: detail.role?.code,
            },
            speMentions: detail.mentions.map((mention) => ({ id: mention.id, name: mention.name })),
            idnps: detail.nationalId || undefined,
            email: detail.email,
            initialEmail: detail.email,
            securedEmail: detail.securedEmail ?? undefined,
            privatePhone: detail.privatePhone ?? undefined,
            contactPhone: detail.contactPhone ?? undefined,
            isReal: currentUser.isReal,

            extraHealthActivityInfoId: detail.extraHealthActivityInfoId || undefined,
            bankInfoObjectId: detail.bankInfoObjectId ?? undefined,
            addressObjectId: detail.addressObjectId || undefined,
            hcsDelegateUserId: detail.hcsDelegateUserId || undefined,
            userHcsPositionId: detail.userHcsPositionId || undefined,
            extraUsageInfoObjectId: detail?.userUsageInfoId ?? undefined,
            extraHealthSystemInfoId: detail?.userHealthSystemInfoId ?? undefined,
            selfMode: true,
        }
    }

    const { data, isLoading } = useGetIdsUsersMyAccountHealthcareserviceHcsId(hcsId, {
        query: {
            select: (rawUserData) => transformUserData(rawUserData),
        },
    })

    return (
        <UserFormContextProvider initialValues={defaultValues}>
            <UserFormErrorContextProvider initialValues={defaultUserErrorValues}>
                {isLoading && <UserLoader />}
                {!isLoading && data && !data.rpps && <UserFormCallout />}
                {data && <MyAccountForm data={data} />}
            </UserFormErrorContextProvider>
        </UserFormContextProvider>
    )
}
